import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useDataSourceSelect } from "../../hooks/inputFormats/useDataSourceSelect";

type DisplayDataSourceProps = {
  dataSourceId: string;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
};

export const DisplayDataSource: React.FC<DisplayDataSourceProps> = ({
  dataSourceId,
  dataAssignments,
}) => {
  const { t } = useTranslation();

  const dataSourceSelect = useDataSourceSelect(dataAssignments);

  const entry = dataSourceSelect.find((d) => d.value === dataSourceId);

  const label = entry?.label;

  if (label) {
    return (
      <span>
        {t("inputFormats.actions.filenameRules.dataSourceValue", {
          dataSource: label,
        })}
      </span>
    );
  }

  return null;
};
